window.periodicalAttendanceLookupEmployee = function(listenSelectComponent, updateSelectComponent) {
  var url = "/api/employees/by_primary_organization_and_periodical_attendance/"
  var updateComponent = $(updateSelectComponent);

  $(listenSelectComponent).on('change', function(event) {
    emptyExistingContent();
    fetchData();
  });

  function fetchData() {
    var orgId = $(listenSelectComponent + " option:selected").val();
    $.get(url + orgId, function(data) {
      updateSelectComponentData(data);
    });
  }

  function updateSelectComponentData(data) {
    $.each(data.employees, function(key,value) {
      updateComponent.append($("<option></option>")
          .attr("value", value.id).text(value.full_name));
    });
  }

  function emptyExistingContent() {
    updateComponent.empty();
  }
}